import { styled } from '@mui/material/styles'
import { palette } from '../../..'
export interface Props {
  type?: string
  disabled?: boolean
  highlightOnHover?: boolean
  size?: number
}

const IconButtonStyled = styled('button', {
  shouldForwardProp: (prop) => prop !== 'highlightOnHover',
})<Props>(({ theme, disabled, highlightOnHover, size }) => ({
  border: '0',
  background: 'none',
  width: `${size || 40}px`,
  height: `${size || 40}px`,
  borderRadius: '2px',
  cursor: disabled ? 'not-allowed' : 'pointer',
  transition: 'background 0.2s ease',
  opacity: disabled ? '.3' : '1',
  '&:hover,&:focus': {
    background: highlightOnHover ? palette.black.plus80 : 'none',
  },
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
}))

export default IconButtonStyled
